import { render } from "./SuccessPayment.vue?vue&type=template&id=01d31de2"
import script from "./SuccessPayment.vue?vue&type=script&lang=js"
export * from "./SuccessPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__